customElements.define(
  "product-model",
  class ProductModel extends HTMLElement {
    constructor() {
      super();
      Shopify.loadFeatures([
        {
          name: "model-viewer-ui",
          version: "1.0",
          onLoad: this.setupModelViewerUI.bind(this),
        },
      ]);
    }
    setupModelViewerUI(errors) {
      if (errors) return;
      this.modelViewerUI = new Shopify.ModelViewerUI(
        this.querySelector("model-viewer")
      );
    }
  }
);

customElements.define(
  "barracuda-product-gallery",
  class BarracudaProductGallery extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.richMedia = [];
      this.init();

      //get current and all slides
      this.content = this.querySelector(".product-gallery-content");
      this.featuredProductGallery = this.closest(".featured-product-gallery");
      this.heightStyle = this.content.classList.contains("defined-height")
        ? this.content.classList.contains("vh-product-gallery")
          ? 2
          : 1
        : false;
      this.thumbnails = this.querySelectorAll(
        ".product-gallery-thumbnails>.thumbnail-media"
      );
      this.thumbnails = this.thumbnails.length > 1 ? this.thumbnails : false;
      this.dots = this.querySelectorAll(".product-gallery-dots>.dot");
      this.slides = this.querySelectorAll(".product-media");
      if (this.querySelector(".product-media.current"))
        this.current = Array.from(this.slides).indexOf(
          this.querySelector(".product-media.current")
        );
      else {
        this.current = 0;
        this.slides[0].classList.add("current");
      }

      //init height
      if (this.slides[this.current].querySelector("img")) {
        this.slides[this.current]
          .querySelector("img")
          .addEventListener("load", () => {
            this.resize();
          });
      }
      this.resize();
      defer(
        (() => {
          //if thumbnails on, select current
          if (this.thumbnails)
            this.thumbnailsGoto(this.thumbnails[this.current], this.current);
          //if dots on, select current
          if (this.dots) this.dotsGoto(this.current);

          window.addEventListener("resize", this.resize.bind(this));

          //add Event listeners to controls
          if (this.slides.length > 1) {
            this.addAction(
              this.querySelector(".media-next"),
              this.next.bind(this)
            );
            this.addAction(
              this.querySelector(".media-prev"),
              this.prev.bind(this)
            );
          }
          this.addAction(
            this.querySelector(".media-zoom-in"),
            this.zoom.bind(this)
          );
          this.addAction(
            this.querySelector(".media-zoom-out"),
            this.zoom.bind(this)
          );
          if (this.thumbnails) {
            this.addAction(
              this.querySelector(".thumbnails-up"),
              this.thumbnailsGoto.bind(this, "up")
            );
            this.addAction(
              this.querySelector(".thumbnails-down"),
              this.thumbnailsGoto.bind(this, "down")
            );
          }
          if (this.dots)
            this.dots.forEach((dot, index) => {
              this.addAction(dot, this.goto.bind(this, index));
            });
          if (this.thumbnails)
            this.thumbnails.forEach((thumbnail, index) => {
              this.addAction(thumbnail, this.goto.bind(this, index));
            });
          this.content.querySelectorAll(".media-icon").forEach((btn) => {
            this.addAction(btn, this.mediaReplace.bind(this, btn));
          });
          this.addAction(
            this.querySelector(".media-close"),
            this.mediaClose.bind(this)
          );
          //swipe
          if (typeof Swipe !== "undefined") {
            new Swipe(this.content);
            this.content.addEventListener("swipe", this.swipe.bind(this));
          }
        }).bind(this)
      );
    }

    init() {}
    addAction(item, fkc) {
      if (item) {
        item.addEventListener("click", (e) => {
          if (e.target.closest(":focus")) e.target.closest(":focus").blur();
          fkc();
        });
        item.addEventListener("keydown", (e) => {
          if (e.key == "Space" || e.key == "Enter") {
            item.click();
          }
        });
      }
    }
    swipe(e) {
      if (e.detail && e.detail.direction)
        switch (e.detail.direction) {
          case "left":
            this.prev();
            break;
          case "right":
            this.next();
            break;
        }
    }
    next() {
      this.goto(this.current < this.slides.length - 1 ? this.current + 1 : 0);
    }
    prev() {
      this.goto(this.current > 0 ? this.current - 1 : this.slides.length - 1);
    }
    goto(target) {
      if (typeof target === "string") {
        let targetEl = this.querySelector(target);
        target = Array.prototype.indexOf.call(this.slides, targetEl);
      }
      if (
        typeof target === "number" &&
        target >= 0 &&
        !this.lock &&
        target != this.current
      ) {
        if (this.mediaOpen) {
          this.mediaClose();
          this.pauseMedia();
        }
        this.lock = true;
        if (this.thumbnails)
          this.thumbnailsGoto(this.thumbnails[target], target);
        if (this.dots) this.dotsGoto(target);
        this.anime = anime
          .timeline({
            duration: 300,
            easing: "linear",
          })
          .add(
            {
              targets: this.slides[target],
              opacity: [0, 1],
            },
            0
          )
          .add(
            {
              targets: this.slides[this.current],
              opacity: [1, 0],
              complete: () => {
                this.slides[this.current].classList.remove("current");
                this.current = target;
                this.slides[this.current].classList.add("current");
                this.lock = false;
              },
            },
            0
          )
          .add(
            !this.fullscreen
              ? {
                  targets: this.content,
                  height: [
                    this.content.offsetHeight,
                    this.slides[target].scrollHeight + "px",
                  ],
                }
              : {},
            0
          )
          .add(
            this.thumbnails && !this.fullscreen
              ? {
                  targets: this.content.querySelector(
                    ".product-gallery-thumbnails"
                  ),
                  maxHeight: [
                    this.content.querySelector(".product-gallery-thumbnails")
                      .style.maxHeight,
                    Math.floor(
                      (this.slides[target].scrollHeight - 48 - 116) / 116
                    ) *
                      116 +
                      "px",
                  ],
                }
              : {},
            0
          );
      }
    }
    zoom() {
      if (this.fullscreen) {
        window.removeEventListener("keydown", this.fullscreenListener);
        this.content.classList.remove("fullscreen");
        anime({
          targets: this.content.querySelector(".thumbnails-navigation"),
          easing: "easeInOutSine",
          duration: 200,
          marginLeft: "0px",
          marginTop: "0px",
        });
        anime({
          targets: this.content.querySelector(
            ".product-media.type-image.current"
          ),
          easing: "easeInOutSine",
          duration: 200,
          height: [
            (el) => {
              if (
                parseFloat(el.querySelector("img").dataset.ratio) <=
                document.documentElement.clientWidth /
                  document.documentElement.clientHeight
              )
                return document.documentElement.clientHeight + "px";
              else
                return (
                  document.documentElement.clientWidth /
                    parseFloat(el.querySelector("img").dataset.ratio) +
                  "px"
                );
            },
            ((el) => {
              if (this.content.classList.contains("adapt"))
                return (
                  this.preZoom.width *
                  parseFloat(el.querySelector("img").dataset.ratio)
                );
              else return this.preZoom.height;
            }).bind(this),
          ],
          width: [
            (el) => {
              if (
                parseFloat(el.querySelector("img").dataset.ratio) <=
                document.documentElement.clientWidth /
                  document.documentElement.clientHeight
              )
                return (
                  parseFloat(el.querySelector("img").dataset.ratio) *
                    document.documentElement.clientHeight +
                  "px"
                );
              else return document.documentElement.clientWidth + "px";
            },
            this.preZoom.width,
          ],
          marginLeft: [
            (el) => {
              if (
                parseFloat(el.querySelector("img").dataset.ratio) <=
                document.documentElement.clientWidth /
                  document.documentElement.clientHeight
              )
                return (
                  (document.documentElement.clientWidth -
                    parseFloat(el.querySelector("img").dataset.ratio) *
                      document.documentElement.clientHeight) /
                  2
                );
              else return 0;
            },
            0,
          ],
          marginTop: [
            (el) => {
              if (
                parseFloat(el.querySelector("img").dataset.ratio) <=
                document.documentElement.clientWidth /
                  document.documentElement.clientHeight
              )
                return 0;
              else
                return (
                  (document.documentElement.clientHeight -
                    document.documentElement.clientWidth /
                      parseFloat(el.querySelector("img").dataset.ratio)) /
                    2 +
                  "px"
                );
            },
            0,
          ],
          complete: (animation) => {
            let el = animation.animatables[0].target;
            el.style.removeProperty("margin-left");
            el.style.removeProperty("margin-top");
            el.style.removeProperty("height");
            el.style.removeProperty("width");
          },
        });
        anime({
          targets: this.content,
          easing: "easeInOutSine",
          duration: 200,
          width: [this.content.offsetWidth + "px", this.preZoom.width],
          height: [this.content.offsetHeight + "px", this.preZoom.height],
          left: this.preZoom.left,
          top: this.preZoom.top,
          complete: (() => {
            this.content.style.removeProperty("position");
            this.content.style.removeProperty("width");
            this.content.style.removeProperty("height");
            this.content.style.removeProperty("left");
            this.content.style.removeProperty("top");
            this.content.style.removeProperty("z-index");
            this.content.parentElement.parentElement.style.removeProperty(
              "min-height"
            );
            this.content.classList.remove("fullscreen");
            if (this.featuredProductGallery)
              this.featuredProductGallery.style.removeProperty("z-index");
            if (this.heightStyle == 2)
              this.content.classList.add("vh-product-gallery");
            this.resize();
            unlockBodyPosition();
          }).bind(this),
        });
      } else {
        this.preZoom = {
          width: this.content.offsetWidth + "px",
          height: this.content.offsetHeight + "px",
          top: this.content.getBoundingClientRect().top + "px",
          left: this.content.getBoundingClientRect().left + "px",
        };
        this.content.style.position = "fixed";
        this.content.style.width = this.preZoom.width;
        this.content.style.height = this.preZoom.height;
        this.content.style.top = this.preZoom.top;
        this.content.style.left = this.preZoom.left;
        this.content.style.zIndex = 9;
        this.content.parentElement.parentElement.style.minHeight =
          this.preZoom.height;

        if (this.featuredProductGallery)
          this.featuredProductGallery.style.zIndex = 9;

        anime({
          targets: this.content.querySelector(".thumbnails-navigation"),
          easing: "easeInOutSine",
          duration: 200,
          marginLeft: "48px",
          marginTop: "48px",
        });
        anime({
          targets: this.content.querySelector(
            ".product-media.type-image.current"
          ),
          easing: "easeInOutSine",
          duration: 200,
          height: ((el) => {
            if (
              parseFloat(el.querySelector("img").dataset.ratio) <=
              document.documentElement.clientWidth /
                document.documentElement.clientHeight
            ) {
              return document.documentElement.clientHeight + "px";
            } else {
              return (
                document.documentElement.clientWidth /
                  parseFloat(el.querySelector("img").dataset.ratio) +
                "px"
              );
            }
          }).bind(this),
          width: (el) => {
            if (
              parseFloat(el.querySelector("img").dataset.ratio) <=
              document.documentElement.clientWidth /
                document.documentElement.clientHeight
            )
              return (
                parseFloat(el.querySelector("img").dataset.ratio) *
                  document.documentElement.clientHeight +
                "px"
              );
            else return document.documentElement.clientWidth + "px";
          },
          marginLeft: [
            0,
            (el) => {
              if (
                parseFloat(el.querySelector("img").dataset.ratio) <=
                document.documentElement.clientWidth /
                  document.documentElement.clientHeight
              )
                return (
                  (document.documentElement.clientWidth -
                    parseFloat(el.querySelector("img").dataset.ratio) *
                      document.documentElement.clientHeight) /
                    2 +
                  "px"
                );
              else return 0;
            },
          ],
          marginTop: [
            0,
            (el) => {
              if (
                parseFloat(el.querySelector("img").dataset.ratio) <=
                document.documentElement.clientWidth /
                  document.documentElement.clientHeight
              )
                return 0;
              else
                return (
                  (document.documentElement.clientHeight -
                    document.documentElement.clientWidth /
                      parseFloat(el.querySelector("img").dataset.ratio)) /
                    2 +
                  "px"
                );
            },
          ],
          complete: (animation) => {
            console.log(animation);
            let el = animation.animatables[0].target;
            el.style.removeProperty("margin-left");
            el.style.removeProperty("margin-top");
            el.style.removeProperty("height");
            el.style.removeProperty("width");
          },
        });
        anime({
          targets: this.content,
          easing: "easeInOutSine",
          duration: 200,
          left: 0,
          top: 0,
          height: document.documentElement.clientHeight + "px",
          width: document.documentElement.clientWidth + "px",
          complete: (() => {
            this.content.classList.add("fullscreen");
          }).bind(this),
        });
        this.fullscreenListener = ((e) => {
          switch (e.key) {
            case "Escape":
              this.zoom();
              break;
            case "ArrowRight":
              this.next();
              break;
            case "ArrowLeft":
              this.prev();
              break;
          }
        }).bind(this);
        window.addEventListener("keydown", this.fullscreenListener);
        if (this.heightStyle == 2)
          this.content.classList.remove("vh-product-gallery");
        if (this.thumbnails) {
          this.content.querySelector(
            ".product-gallery-thumbnails"
          ).style.maxHeight =
            "calc(" +
            Math.floor(
              (document.documentElement.clientHeight - 48 - 116) / 116
            ) +
            " * 116px)";
          if (
            Math.floor(
              (document.documentElement.clientHeight - 48 - 116) / 116
            ) *
              116 >=
            this.querySelector(".product-gallery-thumbnails").scrollHeight
          ) {
            this.querySelector(".thumbnails-controls").classList.add("hidden");
          } else {
            this.querySelector(".thumbnails-controls").classList.remove(
              "hidden"
            );
          }
        }
        lockBodyPosition();
      }
      this.fullscreen = !this.fullscreen;
    }
    thumbnailsGoto(target, position = null) {
      let thumbnailsGallery = this.querySelector(".product-gallery-thumbnails");
      switch (typeof target) {
        case "string":
          target =
            target == "up"
              ? -1 * thumbnailsGallery.offsetHeight
              : thumbnailsGallery.offsetHeight;
          if (target < 0)
            target =
              thumbnailsGallery.scrollTop == 0
                ? thumbnailsGallery.scrollHeight
                : thumbnailsGallery.scrollTop + target;
          else if (target > 0)
            target =
              thumbnailsGallery.scrollTop ==
              thumbnailsGallery.scrollHeight - thumbnailsGallery.offsetHeight
                ? 0
                : thumbnailsGallery.scrollTop + target;
          break;
        case "object":
          target = target.offsetTop;
          this.thumbnails.forEach((thumbnail, index) => {
            if (index != position) thumbnail.classList.remove("current");
            else thumbnail.classList.add("current");
          });
          break;
      }
      anime({
        targets: thumbnailsGallery,
        scrollTop: target,
        duration: 1000,
        easing: "easeOutCubic",
      });
    }
    dotsGoto(target) {
      this.dots.forEach((dot, index) => {
        if (index != target) dot.classList.remove("current");
        else dot.classList.add("current");
      });

      function dotsVisibility(from = null, to = null) {
        if (this.dots.length > 0) {
          this.dots.forEach((dot) => {
            dot.classList.remove("end");
            dot.classList.add("visible");
          });
          if (from) {
            for (let i = 0; i < from; i++) {
              if (this.dots[i]) this.dots[i].classList.remove("visible");
            }
            if (this.dots[from]) this.dots[from].classList.add("end");
          }
          if (to) {
            for (let i = to; i < this.dots.length; i++) {
              if (this.dots[i]) this.dots[i].classList.remove("visible");
            }
            if (this.dots[to - 1] && to != this.dots.length)
              this.dots[to - 1].classList.add("end");
          }
        }
      }
      dotsVisibility = dotsVisibility.bind(this);

      var visibleDots = 5; // count of visible dots
      var dotsCount = this.dots.length;
      if (dotsCount <= visibleDots) dotsVisibility();
      else if (target < 3) dotsVisibility(null, visibleDots);
      else if (target + 3 > dotsCount)
        dotsVisibility(dotsCount - visibleDots, null);
      else dotsVisibility(target - 2, target + 3);
    }
    mediaReplace(btn) {
      this.mediaOpen = true;
      let media = btn.parentElement
        .querySelector("template")
        .content.firstElementChild.cloneNode(true);
      this.richMedia[this.current] = media.firstElementChild;
      btn.parentElement.appendChild(media);
      media.focus();
      btn.parentElement.querySelector("button").classList.add("hidden");
      this.content
        .querySelector(".thumbnails-navigation")
        .classList.add("hidden");
      this.content.querySelectorAll(".media-zoom").forEach((el) => {
        el.classList.add("hidden");
      });
      this.content.querySelector(".media-close").classList.remove("hidden");
    }
    mediaClose() {
      this.mediaOpen = false;
      this.slides[this.current].querySelector(".product-media-frame").remove();
      this.slides[this.current]
        .querySelector("button")
        .classList.remove("hidden");
      this.content.querySelectorAll(".media-zoom").forEach((el) => {
        el.classList.remove("hidden");
      });
      this.content
        .querySelector(".thumbnails-navigation")
        .classList.remove("hidden");
      this.content.querySelector(".media-close").classList.add("hidden");
      this.richMedia.splice(this.current, 1);
    }
    pauseMedia() {
      this.richMedia.forEach((el) => {
        if (el) {
          if (el.classList.contains("js-youtube"))
            el.contentWindow.postMessage(
              '{"event":"command","func":"pauseVideo","args":""}',
              "*"
            );
          else if (el.classList.contains("js-vimeo"))
            el.contentWindow.postMessage(
              '{"event":"command","func":"pauseVideo","args":""}',
              "*"
            );
          else if (el.classList.contains("video")) el.pause();
        }
      });
    }
    resize() {
      if (this.fullscreen) {
        this.content.style.height =
          document.documentElement.clientHeight + "px";
        this.content.style.width = document.documentElement.clientWidth + "px";
        if (this.thumbnails) {
          this.content.querySelector(
            ".product-gallery-thumbnails"
          ).style.maxHeight =
            "calc(" +
            Math.floor(
              (document.documentElement.clientHeight - 48 - 116) / 116
            ) +
            " * 116px)";
          if (
            Math.floor(
              (document.documentElement.clientHeight - 48 - 116) / 116
            ) *
              116 >=
            this.querySelector(".product-gallery-thumbnails").scrollHeight
          ) {
            this.querySelector(".thumbnails-controls").classList.add("hidden");
          } else {
            this.querySelector(".thumbnails-controls").classList.remove(
              "hidden"
            );
          }
        }
      } else {
        if (this.heightStyle < 1)
          this.content.style.height =
            this.slides[this.current].scrollHeight + "px";
        else if (this.heightStyle == 2)
          this.content.style.removeProperty("height");
        if (this.thumbnails) {
          this.content.querySelector(
            ".product-gallery-thumbnails"
          ).style.maxHeight =
            "calc(" +
            Math.floor(
              (this.slides[this.current].scrollHeight - 48 - 116) / 116
            ) +
            " * 116px)";
          if (
            Math.floor(
              (this.slides[this.current].scrollHeight - 48 - 116) / 116
            ) *
              116 >=
            this.querySelector(".product-gallery-thumbnails").scrollHeight
          ) {
            this.querySelector(".thumbnails-controls").classList.add("hidden");
          }
        }
      }
    }
  }
);

customElements.define(
  "barracuda-announcement-bar",
  class BarracudaAnnouncementBar extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.respawn = this.getAttribute("respawn");
      this.sectionId = this.getAttribute("section-id");

      if (
        this &&
        BarracudaStore.functions.getCookie(
          "cookie-announcement-bar-" + this.respawn
        ) == "closed" &&
        !Shopify.designMode
      ) {
        this.classList.add("hide-by-cookie");
        document.documentElement.style.setProperty(
          "--announcement-bar-height",
          0 + "px"
        );
      } else {
        this.closed = false;
        this.current = 0;
        this.time = this.getAttribute("time")
          ? parseInt(this.getAttribute("time")) * 1000
          : 1200;
        this.content = this.querySelector(".announcement-bar-content");
        this.elements = this.querySelectorAll(".announcement");

        this.resize();

        defer(
          (() => {
            let closer = this.querySelector(".hide-by-cookie-toggle");
            if (closer) closer.addEventListener("click", this.close.bind(this));

            window.addEventListener("resize", this.resize.bind(this), false);

            if (this.elements.length > 1)
              this.timeout = setTimeout(
                this.setNext.bind(this, this.current + 1),
                this.time
              );

            if (Shopify.designMode) {
              document.addEventListener("shopify:section:load", (event) => {
                if (event.detail.sectionId == this.sectionId) this.resize();
              });
            }
          }).bind(this)
        );
      }
    }
    close() {
      this.closed = true;

      document.documentElement.style.setProperty(
        "--announcement-bar-height",
        0 + "px"
      );
      this.content.style.minHeight = "0px";
      this.content.style.opacity = "1";
      this.content.style.overflow = "hidden";
      this.content.style.transition = "height 1s ease, opacity 0.2s ease";
      this.content.style.height = "0px";
      this.content.style.opacity = "0";

      if (this.respawn > 0)
        BarracudaStore.functions.setCookie(
          "cookie-announcement-bar-" + this.respawn,
          "closed",
          this.respawn
        );
    }
    resize() {
      if (!this.closed) {
        this.height = 0;
        this.elements.forEach((el) => {
          if (el.firstElementChild.scrollHeight > this.height)
            this.height = el.firstElementChild.scrollHeight;
        });
        if (this.height > 48) {
          this.content.style.height = this.height + "px";
          document.documentElement.style.setProperty(
            "--announcement-bar-height",
            this.height + "px"
          );
        } else {
          this.content.style.height = 48 + "px";
          document.documentElement.style.setProperty(
            "--announcement-bar-height",
            48 + "px"
          );
        }
      }
    }
    setNext(next = this.current + 1, pause = false) {
      if (pause) clearTimeout(this.timeout);
      if (next >= this.elements.length) next = 0;
      if (next != this.current) {
        this.elements[next].classList.add("current");
        this.elements[this.current].classList.remove("current");
        this.current = next;
      }
      if (!pause)
        this.timeout = setTimeout(
          this.setNext.bind(this, this.current + 1),
          this.time
        );
    }
  }
);

customElements.define(
  "barracuda-sub-header",
  class BarracudaSubHeader extends HTMLElement {
    constructor() {
      super();
      this.initialized = false;
      if (document.body.classList.contains("script")) this.init();
      else window.addEventListener("DOMContentLoaded", this.init.bind(this));
    }
    init() {
      if (!this.initialized) {
        this.initialized = true;
        this.content = this.firstElementChild;
        this.opener = this.closest(".sub-header-opener");
        this.opener.addEventListener("mouseenter", this.mouseEnter.bind(this));
        this.opener.addEventListener("mouseleave", this.mouseLeave.bind(this));
        setTimeout(() => {
          this.content.querySelectorAll("img").forEach((el) => {
            el.removeAttribute("loading");
          });
        }, 1000);
      }
    }
    mouseEnter() {
      let header = this.closest("#header");
      if (header.classList.contains("should-be-transparent")) {
        header.classList.remove("should-be-transparent");
        header.classList.remove("can-be-transparent");
        header.classList.add("cant-be-transparent");
      }
    }
    mouseLeave() {
      let header = this.closest("#header");
      if (header.classList.contains("cant-be-transparent")) {
        header.classList.remove("cant-be-transparent");
        header.classList.add("can-be-transparent");
        if (Barracuda.elements.Overlapping)
          Barracuda.elements.Overlapping.check();
      }
    }
  }
);

customElements.define(
  "barracuda-carousel",
  class BarracudaCarousel extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      defer(
        (() => {
          this.content = this.querySelector(".carousel-grid");
          this.dots = this.querySelectorAll(".barracuda-dot");
          this.caruselControls = this.querySelector(
            ".barracuda-carousel-controls"
          );

          this.leftArrow = this.querySelector(".prev");
          this.rightArrow = this.querySelector(".next");
          this.leftArrow.addEventListener("click", this.prev.bind(this));
          this.rightArrow.addEventListener("click", this.next.bind(this));

          this.dots.forEach((el) => {
            el.addEventListener("click", this.goTo.bind(this, el));
          });
          this.currentDot = this.dots[0];
          if (this.currentDot) this.currentDot.classList.add("current");

          window.addEventListener("resize", this.resize.bind(this));

          this.content.addEventListener("scroll", this.updateDots.bind(this));
          this.addEventListener(
            "DotAdded",
            (() => {
              console.log("Dot updated");
              this.dots = this.querySelectorAll(".barracuda-dot");
              this.dots.forEach((el) => {
                el.addEventListener("click", this.goTo.bind(this, el));
              });
              this.resize();
            }).bind(this)
          );
          window.requestAnimationFrame(this.resize.bind(this));
        }).bind(this)
      );
    }
    goTo(dot) {
      const i = dot.dataset.i;
      const currentI = this.currentDot.dataset.i;
      console.log("from", currentI, "to", i);
      if (i != currentI) {
        anime({
          targets: this.content,
          scrollLeft: this.content.querySelector(
            ".small-block:nth-child(" +
              i +
              "), .universal-child:nth-child(" +
              i +
              ")"
          ).offsetLeft,
          easing: "easeInOutCubic",
          duration:
            Math.abs(
              this.content.querySelector(
                ".small-block:nth-child(" +
                  i +
                  "), .universal-child:nth-child(" +
                  i +
                  ")"
              ).offsetLeft -
                this.content.querySelector(
                  ".small-block:nth-child(" +
                    currentI +
                    "), .universal-child:nth-child(" +
                    currentI +
                    ")"
                ).offsetLeft
            ) * 0.75,
          complete: this.updateDots.bind(this),
        });
      }
    }
    next() {
      console.log("next", this.content.offsetWidth);
      anime({
        targets: this.content,
        scrollLeft: () => {
          if (
            this.content.scrollLeft ==
            this.content.scrollWidth - this.content.offsetWidth
          ) {
            console.log("left:", 0);
            return 0;
          } else {
            console.log(
              "left:",
              this.content.scrollLeft + this.content.offsetWidth + this.gapSize
            );
            return (
              this.content.scrollLeft + this.content.offsetWidth + this.gapSize
            );
          }
        },
        easing: "easeInOutCubic",
        duration: this.content.offsetWidth * 0.75,
        complete: this.updateDots.bind(this),
      });
    }
    prev() {
      console.log("prev", this.content.offsetWidth);
      anime({
        targets: this.content,
        scrollLeft: () => {
          if (this.content.scrollLeft == 0) {
            console.log();
            return this.content.scrollWidth - this.content.offsetWidth;
          } else
            return (
              this.content.scrollLeft - this.content.offsetWidth - this.gapSize
            );
        },
        easing: "easeInOutCubic",
        duration: this.content.offsetWidth * 0.75,
        complete: this.updateDots.bind(this),
      });
    }
    resize() {
      this.gapSize = parseInt(
        getComputedStyle(this.content).getPropertyValue("gap")
      );
      this.gapSize = this.gapSize ? this.gapSize : 0;
      const columns = parseInt(
        getComputedStyle(this.content).getPropertyValue("--columns-count")
      );

      this.dots.forEach((el, index) => {
        if (index % columns == 0) {
          el.classList.add("active");
        } else {
          el.classList.remove("active");
        }
      });
      this.updateDots();
    }
    updateDots() {
      this.currentDot = this.querySelector(".barracuda-dot.current");
      let target = parseInt(
        Math.ceil(this.content.scrollLeft / this.content.offsetWidth)
      );
      console.log(target);
      let currentDot = this.querySelectorAll(".active")[target];
      if (currentDot && this.currentDot) {
        if (currentDot != this.currentDot) {
          this.currentDot.classList.remove("current");
          this.currentDot = currentDot;
          this.currentDot.classList.add("current");
        }
      }

      function dotsVisibility(dots, from = null, to = null) {
        if (dots.length > 0) {
          dots.forEach((dot) => {
            dot.classList.remove("end");
            dot.classList.add("visible");
          });
          if (from) {
            for (let i = 0; i < from; i++) {
              if (dots[i]) dots[i].classList.remove("visible");
            }
            if (dots[from]) dots[from].classList.add("end");
          }
          if (to) {
            for (let i = to; i < dots.length; i++) {
              if (dots[i]) dots[i].classList.remove("visible");
            }
            if (dots[to - 1] && to != dots.length)
              dots[to - 1].classList.add("end");
          }
        }
      }
      dotsVisibility = dotsVisibility.bind(this);

      let dots = this.querySelectorAll(".barracuda-dot.active");
      var visibleDots = 5; // count of visible dots
      var dotsCount = dots.length;
      if (dotsCount <= visibleDots) dotsVisibility(dots);
      else if (target < 3) dotsVisibility(dots, null, visibleDots);
      else if (target + 3 > dotsCount)
        dotsVisibility(dots, dotsCount - visibleDots, null);
      else dotsVisibility(dots, target - 2, target + 3);

      if (this.querySelectorAll(".barracuda-dot.visible").length == 1) {
        this.caruselControls.style.display = "none";
      } else {
        this.caruselControls.style.display = "flex";
      }
    }
  }
);

customElements.define(
  "barracuda-popup-opener",
  class BarracudaPopupOpener extends HTMLElement {
    constructor() {
      super();
      this.initialized = false;
      if (document.body.classList.contains("script")) this.init();
      else window.addEventListener("DOMContentLoaded", this.init.bind(this));
    }
    init() {
      if (!this.initialized) {
        this.initialized = true;
        this.url = this.getAttribute("url");
        this.sectionSelector = this.getAttribute("section");
        if (this.url && this.sectionSelector)
          this.querySelector("a").addEventListener(
            "click",
            this.open.bind(this)
          );
      }
    }
    open(e) {
      prevent(e);
      axios
        .get(this.url)
        .then(
          function (response) {
            if (response.data) {
              var x = document.createElement("html");
              x.innerHTML = response.data;
              var source = x.querySelector(this.sectionSelector);
              if (source) {
                let target = document.querySelector(".overlay-content");

                var currentContent = document.querySelector(
                  ".overlay-content-content>form, .overlay-content-content>div"
                );
                if (
                  currentContent &&
                  currentContent.dataset.source &&
                  document.querySelector("#" + currentContent.dataset.source)
                )
                  document
                    .querySelector("#" + currentContent.dataset.source)
                    .appendChild(currentContent);

                target.innerHTML = "";

                var closer = document.createElement("a");
                closer.innerHTML =
                  '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>';
                closer.classList.add("icon", "icon-x", "overlay-closer");

                var content = document.createElement("div");
                content.appendChild(source);
                content.classList.add(
                  "overlay-content-content",
                  "scroll-inside"
                );
                if (source.dataset.type)
                  content.classList.add(...source.dataset.type.split(" "));

                target.appendChild(closer);
                target.appendChild(content);

                if (content.querySelector(".map")) {
                  setTimeout(function () {
                    Barracuda.loadMapsScript(content);
                  }, 200);
                }

                Barracuda.init();
                Barracuda.elements.init();
                Barracuda.aos.refreshHard();
                target.classList.remove("loading");
                lockBodyPosition();
                document.body.classList.add("show-overlay");
              }
            }
          }.bind(this)
        )
        .catch(function (error) {
          console.warn(error);
        });
      return false;
    }
  }
);

customElements.define(
  "barracuda-tabs",
  class BarracudaTabs extends HTMLElement {
    constructor() {
      super();

      this.content = this.querySelector(".tabs-content");
      this.tabOpeners = this.querySelectorAll(".tab-opener");
      this.tabContents = this.querySelectorAll(".tab-content");
      this.current = parseInt(
        this.querySelector(".tab-opener.active").dataset.i
      );
      this.tabOpeners.forEach((el, key) => {
        el.addEventListener("click", this.showTab.bind(this, key));
      });
    }
    showTab(i, animation = true) {
      console.log("Currrent: ", this.current, "Next: ", i);
      this.tabOpeners.forEach((el, key) => {
        if (i != key) el.classList.remove("active");
      });
      this.tabOpeners[i].classList.add("active");

      if (animation) {
        anime
          .timeline({
            duration: 300,
            easing: "linear",
          })
          .add(
            {
              targets: this.tabContents[this.current],
              opacity: [1, 0],
              maxHeight: [
                this.tabContents[this.current].scrollHeight + "px",
                this.tabContents[i].scrollHeight + "px",
              ],
              before: function () {
                this.tabContents[this.current].style.width =
                  this.tabContents[this.current].offsetWidth + "px";
                this.tabContents[this.current].style.position = "absolute";
                this.tabContents[this.current].style.overflow = "hidden";
              }.bind(this),
              complete: function () {
                this.tabContents[this.current].classList.remove("active");
                this.tabContents[this.current].style.removeProperty("position");
                this.tabContents[this.current].style.removeProperty("width");
                this.tabContents[this.current].style.removeProperty(
                  "max-height"
                );
                this.tabContents[this.current].style.removeProperty("overflow");
              }.bind(this),
            },
            0
          )
          .add(
            {
              targets: this.content,
              height: [
                this.tabContents[this.current].scrollHeight + "px",
                this.tabContents[i].scrollHeight + "px",
              ],
              complete: function () {
                this.content.style.removeProperty("height");
              }.bind(this),
            },
            0
          )
          .add(
            {
              targets: this.tabContents[i],
              opacity: [0, 1],
              maxHeight: [
                this.tabContents[this.current].scrollHeight + "px",
                this.tabContents[i].scrollHeight + "px",
              ],
              complete: function () {
                this.tabContents[i].classList.add("active");
                this.tabContents[i].style.removeProperty("max-height");
                this.current = i;
              }.bind(this),
            },
            0
          );
      } else {
        this.tabContents.forEach((el, key) => {
          if (i != key) el.classList.remove("active");
        });
        this.tabContents[i].classList.add("active");
      }
    }
    customize(i) {
      this.showTab(i, false);
    }
  }
);

customElements.define(
  "barracuda-product-recommendations",
  class BarracudaProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.initialized = false;
      if (document.body.classList.contains("script")) this.init();
      else window.addEventListener("DOMContentLoaded", this.init.bind(this));
    }
    init() {
      if (!this.initialized) {
        this.initialized = true;
        this.url = document.body.dataset.url + this.dataset.url;
        this.hasContent = this.dataset.hasContent;
        if (this.hasContent == "false")
          axios
            .get(this.url)
            .then(
              function (response) {
                if (response.data) {
                  var x = document.createElement("html");
                  x.innerHTML = response.data;
                  let betterOne = x.querySelector(
                    "barracuda-product-recommendations"
                  );
                  if (betterOne.firstElementChild)
                    this.appendChild(betterOne.firstElementChild);
                  this.hasContent = true;

                  Barracuda.aos.refreshHard();
                }
              }.bind(this)
            )
            .catch(function (error) {
              console.warn(error);
            });
      }
    }
  }
);

customElements.define(
  "barracuda-market-selector",
  class BarracudaMarketSelector extends HTMLElement {
    constructor() {
      super();

      this.select = this.querySelector("select");
      this.select.addEventListener("mousedown", this.addOptions.bind(this));
      this.select.addEventListener("change", this.change.bind(this));
    }
    addOptions() {
      let value = this.select.value;
      let offsetWidth = this.select.offsetWidth;
      if (offsetWidth > 0)
        this.select.style.width =
          offsetWidth - parseInt(this.select.style.paddingRight) + "px";
      this.querySelectorAll("select+select option").forEach((el) => {
        this.select.appendChild(el);
      });
      this.select.value = value;
      this.select.removeEventListener("mousedown", this.addOptions.bind(this));
    }
    change() {
      this.closest("form").submit();
    }
  }
);

customElements.define(
  "barracuda-input-date",
  class BarracudaInputDate extends HTMLElement {
    constructor() {
      super();
      this.initialized = false;
      if (document.body.classList.contains("script")) this.init();
      else window.addEventListener("DOMContentLoaded", this.init.bind(this));
    }
    init() {
      if (!this.initialized) {
        this.initialized = true;
        this.inputs = this.querySelectorAll("input");
        this.values = ["", "", ""];
        this.parent = this.getAttribute("input")
          ? document.querySelector("#" + this.getAttribute("input"))
          : false;

        if (this.parent) {
          console.log(this.parent.value);
          if (this.parent.value == "") {
            this.classList.add("empty");
          }
          this.inputs.forEach((input, index) => {
            input.addEventListener(
              "keyup",
              this.change.bind(this, input, index)
            );
            input.addEventListener(
              "change",
              this.change.bind(this, input, index)
            );
          });
        }
        this.querySelector("span").addEventListener(
          "click",
          this.focusInput.bind(this)
        );
      }
    }
    focusInput() {
      this.inputs[0].focus();
    }
    change(input, index) {
      let value = parseInt(input.value);
      value = value ? value : value == 0 ? value : "";
      this.values[index] = value;
      input.value = value;

      let day = ("0" + this.values[0]).slice(-2);
      let month = ("0" + this.values[1]).slice(-2);
      let year = ("0" + this.values[2]).slice(-4);

      this.parent.value = year + "-" + month + "-" + day;
      if (this.parent.value != "" && this.parent.value != "0-0-0")
        this.classList.remove("empty");
      else this.classList.add("empty");
    }
  }
);

customElements.define(
  "barracuda-icon",
  class extends HTMLElement {
    constructor() {
      super();
      this.icon = this.getAttribute("icon");
      if (feather && feather.icons[this.icon])
        this.innerHTML = feather.icons[this.icon].toSvg();
    }
  }
);

customElements.define(
  "barracuda-cookies-popup",
  class extends HTMLElement {
    constructor() {
      super();
      this.content = this.querySelector("#cookies-popup-content");
      console.log(
        "Cookies state: ",
        BarracudaStore.functions.getCookie("cookie-bar")
      );
      switch (BarracudaStore.functions.getCookie("cookie-bar")) {
        case "confirm":
          Barracuda.cookies = Object.assign(Barracuda, {
            cookies: { accepted: true, rejected: false },
          });
          break;
        case "reject":
          Barracuda.cookies = Object.assign(Barracuda, {
            cookies: { accepted: false, rejected: true },
          });
          break;
        default:
          Barracuda.cookies = Object.assign(Barracuda, {
            cookies: { accepted: false, rejected: false },
          });
          if (!Shopify.designMode) this.show();
      }
      this.querySelector("#cookies-popup-confirm-button").addEventListener(
        "click",
        this.hide.bind(this, true, "confirm")
      );
      let xButton = this.querySelector(".icon.icon-x");
      if (xButton)
        xButton.addEventListener("click", this.hide.bind(this, true, "reject"));

      if (Shopify.designMode) {
        document.addEventListener("shopify:section:select", (event) => {
          if (event.detail.sectionId == this.getAttribute("section-id"))
            this.show(0);
        });
        document.addEventListener("shopify:section:deselect", (event) => {
          if (event.detail.sectionId == this.getAttribute("section-id"))
            this.hide();
        });
      }
    }
    show(timeout = 1000) {
      setTimeout(() => {
        Barracuda.fadeIn(
          this.content,
          () => {
            this.content.classList.remove("hide");
          },
          Barracuda.duration * 2
        );
      }, timeout);
    }
    hide(useCookie = false, state = "confirm") {
      if (useCookie)
        BarracudaStore.functions.setCookie("cookie-bar", state, 120);
      Barracuda.fadeOut(
        this.content,
        () => {
          this.content.classList.add("hide");
        },
        Barracuda.duration * 2
      );
    }
  }
);

customElements.define(
  "barracuda-image-loader",
  class extends HTMLElement {
    constructor() {
      super();
      this.loadingObj = this.querySelector(".loading.placeholder");
      if (!this.loading) {
        this.loadingObj = document.createElement("div");
        this.loadingObj.classList.add("loading", "placeholder");
        this.appendChild(this.loadingObj);
      }

      this.img = this.querySelector(".loader-target");
      if (this.img.complete && this.img.naturalHeight !== 0) this.imageLoaded();
      else this.img.addEventListener("load", this.imageLoaded.bind(this));
    }
    imageLoaded() {
      anime({
        targets: ".loading.placeholder",
        opacity: 0,
        duration: 100,
        easing: "easeOutSine",
        complete: () => {
          /* this.loadingObj.remove(); */
        },
      });
    }
  }
);

customElements.define(
  "barracuda-add-to-cart-button",
  class extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector(".button");
      this.addEventListener("click", this.add.bind(this));
    }
    add() {
      if (this.button) this.button.classList.add("loading");
      var data = {
        items: [
          {
            quantity: parseInt(
              this.dataset.quantity ? this.dataset.quantity : 1
            ),
            id: parseInt(this.dataset.id),
          },
        ],
      };
      axios
        .post("/cart/add.js", data)
        .then(
          function (response) {
            /* refresh cart, animate badge... */
            barracudaCart.refreshCartIcon();
            barracudaCart.animateCartIcon();
            if (this.button) this.button.classList.remove("loading");
          }.bind(this)
        )
        .catch(
          function (error) {
            if (this.button) this.button.classList.remove("loading");
            console.error(error);
          }.bind(this)
        );
    }
  }
);

customElements.define(
  "barracuda-small-block-badges",
  class BarracudaSmallBlockBadges extends HTMLElement {
    constructor() {
      super();
      this.initialized = false;
      if (document.body.classList.contains("script")) this.init();
      else window.addEventListener("DOMContentLoaded", this.init.bind(this));
    }
    init() {
      if (!this.initialized) {
        this.initialized = true;
        this.content = this.querySelector(".content");
        this.badges = this.querySelectorAll(".small-block-badge");
        this.opener = this.querySelector(".open");
        this.closer = this.querySelector(".close");

        if (this.content && this.badges && this.opener && this.closer) {
          this.resize();
          window.addEventListener("resize", this.resize.bind(this));
          this.opener.addEventListener("click", this.toggle.bind(this));
          this.closer.addEventListener("click", this.toggle.bind(this));
        }
      }
    }
    resize() {
      if (this.content.scrollHeight == this.content.offsetHeight) {
        this.classList.remove("opened", "closed");
      } else {
        this.classList.add("closed");
        this.opener.style.removeProperty("order");
        let filled_width = 0;
        let final_position = 0;
        this.badges.forEach((el, index) => {
          if (
            filled_width + el.getBoundingClientRect().width + 36 <=
            this.content.getBoundingClientRect().width
          ) {
            final_position = index + 1;
          }
          filled_width += el.getBoundingClientRect().width + 6;
        });
        if (final_position != 0) {
          this.opener.style.order = final_position;
        }
      }
    }
    toggle(event, animation = true) {
      console.log(event);
      event.preventDefault();
      if (this.classList.contains("closed")) {
        /* open list */
        this.classList.add("opened");
        this.classList.remove("closed");
        this.original_height = this.content.offsetHeight;
        this.anime = anime
          .timeline({
            duration: 100,
            easing: "linear",
          })
          .add(
            {
              targets: this.content,
              height: [
                this.content.offsetHeight + "px",
                this.content.scrollHeight + 5 + "px",
              ],
            },
            0
          );
      } else {
        /* close list */
        this.classList.add("closed");
        this.classList.remove("opened");
        this.anime = anime
          .timeline({
            duration: 100,
            easing: "linear",
          })
          .add(
            {
              targets: this.content,
              height: [
                this.content.scrollHeight + "px",
                this.original_height + "px",
              ],
            },
            0
          );
      }
    }
  }
);

customElements.define(
  "barracuda-small-block-variant-picker",
  class extends HTMLElement {
    constructor() {
      super();
      defer(
        (() => {
          this.addEventListener("click", this.click.bind(this), false);
          this.block = this.closest(".small-block");
          this.blockTop = this.block.querySelector(".small-block-top");
          this.images = this.blockTop.querySelectorAll(
            "barracuda-image-loader img"
          );
        }).bind(this)
      );
    }
    click() {
      if (this.dataset.image) {
        this.block
          .querySelectorAll("barracuda-small-block-variant-picker")
          .forEach((el) => {
            if (this != el) el.unselect();
          });
        this.select();
      }
    }
    select() {
      /* Image selection */
      this.image = this.images[0].cloneNode(true);
      this.image.classList.add("variant-image");
      this.image.setAttribute(
        "src",
        this.image
          .getAttribute("src")
          .replace(/^(.*\/)[^\/]*(.*)$/, this.dataset.image + "$2")
      );
      this.image.setAttribute(
        "srcset",
        this.image
          .getAttribute("srcset")
          .replace(/^(.*\/)[^\/]*(.*)$/, this.dataset.image + "$2")
      );
      this.image.style.opacity = "0";
      this.image.style.zIndex = 2;
      this.image.style.transition = "0.3s ease opacity, 0.3s ease transform";

      this.blockTop
        .querySelector("barracuda-image-loader")
        .appendChild(this.image);
      setTimeout(() => {
        this.image.style.opacity = 1;
      }, 10);

      /* Price selection */
      this.price = this.block.querySelector(".price");
      this.priceTemplate = this.querySelector("template.template-price");
      if (this.priceTemplate.content.firstElementChild)
        this.price.innerHTML =
          this.priceTemplate.content.firstElementChild.innerHTML;

      this.classList.add("selected");
    }
    unselect() {
      this.classList.remove("selected");

      if (this.image) {
        setTimeout(() => {
          this.image.style.opacity = 0;
          setTimeout(() => {
            this.image.remove();
          }, 300);
        }, 100);
      }
    }
  }
);

customElements.define(
  "barracuda-promotion-popup",
  class extends HTMLElement {
    constructor() {
      super();
      this.template = this.firstElementChild;
      this.respawnTime = this.getAttribute("respawn-time");

      if (Shopify.designMode) {
        document.addEventListener("shopify:section:select", (event) => {
          if (event.detail.sectionId == this.getAttribute("section-id"))
            this.show(0);
        });
        document.addEventListener("shopify:section:deselect", (event) => {
          if (event.detail.sectionId == this.getAttribute("section-id"))
            overlayClear();
        });
      } else {
        this.show();
      }
    }
    show(timeout = 1000) {
      setTimeout(() => {
        console.log(
          "popup-promotion-" + this.respawnTime,
          BarracudaStore.functions.getCookie(
            "popup-promotion-" + this.respawnTime
          )
        );
        if (
          (BarracudaStore.functions.getCookie &&
            BarracudaStore.functions.getCookie(
              "popup-promotion-" + this.respawnTime
            ) != "closed") ||
          Shopify.designMode
        ) {
          if (
            !document.body.classList.contains("show-overlay") ||
            Shopify.designMode
          ) {
            setTimeout(() => {
              let overlayContent = document.querySelector(".overlay-content");
              let copy = this.template.cloneNode(true);
              copy.classList.remove("hidden");
              overlayContent.innerHTML = "";
              overlayContent.appendChild(copy);
              overlayContent.classList.remove("loading");
              if (copy.dataset.position) {
                overlayContent.classList.add(copy.dataset.position);
                overlayContent.dataset.lastPosition = copy.dataset.position;
              }
              lockBodyPosition();
              document.body.classList.add("show-overlay");
              overlayContent
                .querySelector(".overlay-closer")
                .addEventListener("click", () => {
                  BarracudaStore.functions.setCookie(
                    "popup-promotion-" + this.respawnTime,
                    "closed",
                    this.respawnTime
                  );
                });
              overlayContent
                .querySelector("a.button")
                .addEventListener("click", () => {
                  BarracudaStore.functions.setCookie(
                    "popup-promotion-" + this.respawnTime,
                    "closed",
                    this.respawnTime
                  );
                });
            }, 300);
          } else {
            setTimeout(this.show.bind(this), 5000);
          }
        }
      }, timeout);
    }
    hide() {
      overlayClick(null, true);
    }
  }
);

customElements.define(
  "barracuda-newsletter-popup",
  class extends HTMLElement {
    constructor() {
      super();
      this.template = this.firstElementChild;
      this.respawnTime = this.getAttribute("respawn-time");

      if (Shopify.designMode) {
        document.addEventListener("shopify:section:select", (event) => {
          if (event.detail.sectionId == this.getAttribute("section-id"))
            this.show(0);
        });
        document.addEventListener("shopify:section:deselect", (event) => {
          if (event.detail.sectionId == this.getAttribute("section-id"))
            overlayClear();
        });
      } else {
        this.show();
      }
    }
    show(timeout = 1000) {
      setTimeout(() => {
        // Check if user just add a newsletter
        if (
          document.querySelector(
            ".newsletter-form .form-message.ajax-form-success"
          )
        )
          BarracudaStore.functions.setCookie(
            "popup-newsletter-" + this.respawnTime,
            "closed",
            2592000
          );
        else if (
          (BarracudaStore.functions.getCookie &&
            BarracudaStore.functions.getCookie(
              "popup-newsletter-" + this.respawnTime
            ) != "closed") ||
          Shopify.designMode
        ) {
          if (
            !document.body.classList.contains("show-overlay") ||
            Shopify.designMode
          ) {
            let overlayContent = document.querySelector(".overlay-content");
            let copy = this.template.cloneNode(true);
            copy.classList.remove("hidden");
            overlayContent.innerHTML = "";
            console.log("cleaning");
            overlayContent.appendChild(copy);
            overlayContent.classList.remove("loading");
            console.log("removing loading");
            lockBodyPosition();
            document.body.classList.add("show-overlay");
            overlayContent
              .querySelector(".overlay-closer")
              .addEventListener("click", () => {
                BarracudaStore.functions.setCookie(
                  "popup-newsletter-" + this.respawnTime,
                  "closed",
                  this.respawnTime
                );
              });
          } else {
            setTimeout(this.show.bind(this), 5000);
          }
        }
      }, timeout);
    }
    hide() {
      overlayClick(null, true);
    }
  }
);

customElements.define(
  "barracuda-age-verifier-popup",
  class extends HTMLElement {
    constructor() {
      super();
      this.template = this.firstElementChild;
      this.respawnTime = 1;

      if (Shopify.designMode) {
        document.addEventListener("shopify:section:select", (event) => {
          if (event.detail.sectionId == this.getAttribute("section-id"))
            this.show(0);
        });
        document.addEventListener("shopify:section:deselect", (event) => {
          if (event.detail.sectionId == this.getAttribute("section-id")) {
            document
              .querySelector(".overlay")
              .setAttribute("onclick", "overlayClick(null, true);");
            overlayClear();
          }
        });
      } else {
        this.show();
      }
    }
    confirm() {
      BarracudaStore.functions.setCookie(
        "popup-age-verifier-" + this.respawnTime,
        "confirm",
        this.respawnTime
      );
      this.hide();
    }
    show() {
      if (
        (BarracudaStore.functions.getCookie &&
          BarracudaStore.functions.getCookie(
            "popup-age-verifier-" + this.respawnTime
          ) != "confirm") ||
        Shopify.designMode
      ) {
        let overlayContent = document.querySelector(".overlay-content");
        let copy = this.template.cloneNode(true);
        copy.classList.remove("hidden");
        overlayContent.innerHTML = "";
        overlayContent.appendChild(copy);
        overlayContent.classList.remove("loading");
        document.body.classList.add("show-overlay");
        overlayContent
          .querySelector(".confirm-button")
          .addEventListener("click", this.confirm.bind(this));
        document.querySelector(".overlay").removeAttribute("onclick");
      }
    }
    hide() {
      document
        .querySelector(".overlay")
        .setAttribute("onclick", "overlayClick(event);");
      overlayClick(null, true);
    }
  }
);

customElements.define(
  "barracuda-div-by-screen-width",
  class extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.desktop = this.querySelector(".desktop");
      this.mobile = this.querySelector(".mobile");
      if (this.dataset.section)
        window.addEventListener(
          "shopify:section:load",
          ((event) => {
            if (event.detail.sectionId == this.dataset.section) {
              this.init();
            }
          }).bind(this)
        );
      this.init();
      window.addEventListener("resize", this.init.bind(this));
    }
    init() {
      this.desktop.classList.remove("hidden");
      if (this.desktop.scrollWidth <= this.desktop.offsetWidth) {
        this.desktop.classList.remove("hidden");
        this.mobile.classList.add("hidden");
      } else {
        this.desktop.classList.add("hidden");
        this.mobile.classList.remove("hidden");
      }
    }
  }
);

customElements.define(
  "barracuda-popup-quick-view",
  class extends HTMLElement {
    constructor() {
      super();
      this.template = this.querySelector("template");
      this.sectionId = this.getAttribute("section-id");
      document.body.classList.add("use-popup-quick-view");

      if (Shopify.designMode) {
        document.addEventListener("shopify:section:select", (event) => {
          if (event.detail.sectionId == this.sectionId) this.openInEditor();
        });
        document.addEventListener("shopify:block:select", (event) => {
          if (event.detail.sectionId == this.sectionId) this.openInEditor();
        });
        document.addEventListener("shopify:section:deselect", (event) => {
          if (event.detail.sectionId == this.sectionId) this.closeInEditor();
        });
        document.addEventListener("shopify:block:deselect", (event) => {
          if (event.detail.sectionId == this.sectionId) this.closeInEditor();
        });
        document.addEventListener("shopify:section:unload", (event) => {
          if (event.detail.sectionId == this.sectionId)
            document.body.classList.remove("use-popup-quick-view");
        });
        document.addEventListener("shopify:section:load", (event) => {
          if (event.detail.sectionId == this.sectionId)
            document.body.classList.add("use-popup-quick-view");
        });
      }
    }
    cleanOverlayContent() {
      var currentContent = document.querySelector(
        ".overlay-content-content>form, .overlay-content-content>div"
      );
      if (currentContent && currentContent.dataset.source) {
        var t = document.querySelector("#" + currentContent.dataset.source);
        if (t) t.appendChild(currentContent);
      }
    }
    closeInEditor() {
      overlayClick(null, true);
    }
    openInEditor() {
      this.cleanOverlayContent();
      this.open();
      this.injectOverlayContent();
    }
    open(event) {
      if (event) {
        this.openButton = event.target.closest(".button");
        if (this.openButton) this.openButton.classList.add("loading");
      }
      this.cleanOverlayContent();
      this.overlayContent = document.querySelector(".overlay-content");
      this.overlayContent.innerHTML = "";
      this.overlayContent.classList.add("loading");
      lockBodyPosition();
    }
    injectOverlayContent(template = this.template) {
      this.overlayContent.classList.remove("loading");

      console.log(template);
      /* this.overlayContent.appendChild(); */
      this.overlayContent.innerHTML =
        template.content.firstElementChild.cloneNode(true).innerHTML;

      Barracuda.elements.init();
      Barracuda.initCollapsible();
      barracudaCart.appendAddToCartButton(
        document
          .querySelector(".overlay-content")
          .querySelector(".barracuda-cart-addToCartButton")
      );
      document.body.classList.add("show-overlay");
      if (this.openButton) this.openButton.classList.remove("loading");
    }
    load(url, event) {
      this.cleanOverlayContent();
      this.open(event);
      function handleResponse(request) {
        console.log(request);
        let dom = new DOMParser().parseFromString(
          JSON.parse(request.responseText)[this.sectionId],
          "text/html"
        );
        let template = dom.querySelector("#popup-quick-view");
        this.injectOverlayContent(template);
      }
      const request = new XMLHttpRequest();
      request.addEventListener("load", handleResponse.bind(this, request));
      console.log(this.sectionId);
      request.open("GET", url + "?sections=" + this.sectionId, true);
      request.send();
    }
  }
);

customElements.define(
  "barracuda-popup-quick-view-opener",
  class extends HTMLElement {
    constructor() {
      super();
      this.addEventListener("click", this.click.bind(this), false);
      this.product = this.getAttribute("product");
    }
    click(e) {
      if (!e.target.closest(".prevent-quickview")) {
        prevent(e);
        let popup = document.querySelector("barracuda-popup-quick-view");
        popup.load(this.product.split("?")[0], e);
      }
    }
  }
);

/* GOOGLE icons */
customElements.define(
  "barracuda-google-icon",
  class extends HTMLElement {
    constructor() {
      super();
      if (this.innerHTML == "") {
        this.loadIcon(this.getAttribute("icon"));
      }
    }
    loadIcon(icon_name) {
      var xhr = new XMLHttpRequest();
      xhr.open(
        "GET",
        "https://fonts.gstatic.com/s/i/short-term/release/materialsymbolsrounded/" +
          icon_name +
          "/wght300/24px.svg"
      );
      xhr.onload = function () {
        if (xhr.status === 200) {
          var response = xhr.responseText;
          this.innerHTML = response;
        }
      }.bind(this);
      xhr.send();
    }
  }
);

/* Recently viewed */
customElements.define(
  "barracuda-recently-viewed",
  class extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.getAttribute("section-id");
      this.maxCount = parseInt(this.getAttribute("products-count"));
      this.url = this.getAttribute("url");
      this.querySelector(".barracuda-recently-viewed-target").innerHTML = "";
      // get product handles from storage
      let productsInSection = [];
      let productsFromStorage = JSON.parse(
        localStorage.getItem("recently-products")
      );
      //  push them to array
      if (
        Array.isArray(productsFromStorage) &&
        productsFromStorage.length > 0
      ) {
        productsFromStorage.forEach((element) => {
          // if array can handle more
          if (productsInSection.length <= this.maxCount) {
            // and try to load the product
            function handleResponse(request) {
              let dom = new DOMParser().parseFromString(
                JSON.parse(request.responseText)[this.sectionId],
                "text/html"
              );
              let productBlock = dom.querySelector(
                ".small-block, .recently-viewed-product"
              );
              if (productBlock) {
                let newProductBlock = productBlock.cloneNode(true);
                this.querySelector(
                  ".barracuda-recently-viewed-target"
                ).appendChild(newProductBlock);
                /* Need add a dot for it */
                let dot =
                  this.querySelector(
                    "template.dot"
                  ).content.firstElementChild.cloneNode(true);
                /* First dot needs to be current dot */
                if (
                  this.querySelector(".barracuda-recently-viewed-target")
                    .children.length == 1
                )
                  dot.classList.add("current");
                dot.dataset.i = this.querySelectorAll(
                  ".small-block, .recently-viewed-product"
                ).length;
                this.querySelector(".dots").appendChild(dot);
                /* Inform carousel that we added something */
                window.requestAnimationFrame(
                  (() => {
                    this.querySelector("barracuda-carousel").dispatchEvent(
                      new CustomEvent("DotAdded")
                    );
                  }).bind(this)
                );
              }
            }
            if (element) {
              productsInSection.push(element);
              const request = new XMLHttpRequest();
              request.addEventListener(
                "load",
                handleResponse.bind(this, request)
              );
              // build url
              let url =
                this.url +
                "products/" +
                element +
                "?sections=" +
                this.sectionId;
              request.open("GET", url, true);
              request.send();
            }
          }
        });
      } else {
        // no products
        const parent = this.closest(".cart-recently-viewed");
        if (parent) parent.remove();
      }
    }
  }
);

/**
 *    INFINITY CAROUSEL
 */

class InfinityCarousel extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    defer(
      (() => {
        this.init();
        window.requestAnimationFrame(() => {
          this.checkPosition();
        });
      }).bind(this)
    );
  }

  init() {
    this.scrollPosition = 0;
    this.blockWidth = 0;
    // Set up attributes
    this.speed = parseInt(this.getAttribute("speed")) || 0;
    this.autoplayAttr =
      this.speed == 0 ? false : this.getAttribute("autoplay") === "true";
    this.direction = this.getAttribute("direction") || "to-right";

    // Set up initial values
    this.carouselBlocksWrapper = this.querySelector(".carousel-blocks-wrapper");
    this.blocks = this.carouselBlocksWrapper.children;
    this.carouselContainer = this.carouselBlocksWrapper.parentNode;

    // Prepare copies of carouselBlocksWrapper for left and right
    this.carouselBlocksWrapperLeft = this.carouselBlocksWrapper.cloneNode(true);
    this.carouselBlocksWrapperLeft.classList.add("left-copy");
    this.carouselBlocksWrapperRight =
      this.carouselBlocksWrapper.cloneNode(true);
    this.carouselBlocksWrapperRight.classList.add("right-copy");

    // Append them before and after carouselBlocksWrapper
    this.carouselContainer.insertBefore(
      this.carouselBlocksWrapperLeft,
      this.carouselBlocksWrapper
    );
    this.carouselContainer.appendChild(this.carouselBlocksWrapperRight);

    // Check and fix widths
    this.resize();

    // Set first into center
    this.set(0, "auto", false);

    console.log("autoplay carousel:", this.autoplayAttr);
    // Set up interval for autoplay
    if (this.autoplayAttr) {
      this.autoplay();
      // Add listeners for stopping autoplay
      this.addEventListener("mouseenter", this.pause.bind(this));
      this.addEventListener("mouseleave", this.play.bind(this));
      // Shopify editor listeners
      if (Shopify.designMode) {
        document.addEventListener("shopify:section:select", (event) => {
          if (event.detail.sectionId == this.getAttribute("section-id"))
            this.pause();
        });
        document.addEventListener("shopify:section:deselect", (event) => {
          if (event.detail.sectionId == this.getAttribute("section-id"))
            this.play();
        });
      }
    }
    if (Shopify.designMode) {
      // Shopify editor listeners
      document.addEventListener("shopify:block:select", (event) => {
        if (event.detail.sectionId == this.getAttribute("section-id")) {
          const element = this.querySelector(
            ".shopify-block-" + event.detail.blockId
          );
          console.log("select block ", element);
          if (element) {
            const i = parseInt(element.getAttribute("nth")) - 1;
            setTimeout(
              (() => {
                this.set(i);
              }).bind(this),
              100
            );
            setTimeout(
              (() => {
                this.set(i);
              }).bind(this),
              1000
            );
          }
        }
      });
      document.addEventListener("shopify:block:deselect", (event) => {
        if (event.detail.sectionId == this.getAttribute("section-id"))
          this.play();
      });
    }
    // Add mouseMove handle
    this.arrows = {
      left: this.querySelector(".infinity-carousel-button-cursor.before"),
      right: this.querySelector(".infinity-carousel-button-cursor.next"),
    };
    if (this.arrows.left && this.arrows.right) {
      this.addEventListener("mousemove", this.mouseMove.bind(this));
      this.addEventListener("mouseleave", this.hideArrows.bind(this));
      this.addEventListener("click", this.clickMouse.bind(this));
    }
    // Add in-view-handler
    this.inViewHandler();
    window.addEventListener("scroll", this.inViewHandler.bind(this), false);
    // Add scroll handle
    this.carouselContainer.addEventListener(
      "scroll",
      this.scrollHandle.bind(this),
      false
    );
    // Add resize handle
    window.addEventListener("resize", this.resize.bind(this), false);
    // Add listeners for controls
    this.addEventListener(
      "carousel:controls:backward",
      this.backward.bind(this)
    );
    this.addEventListener("carousel:controls:forward", this.forward.bind(this));
    this.addEventListener("carousel:controls:pause", this.stop.bind(this));
    this.addEventListener("carousel:controls:play", this.autoplay.bind(this));
    this.addEventListener(
      "carousel:action",
      ((e) => {
        switch (e.detail.action) {
          case "set":
            this.set(e.detail.nth);
            break;
          case "pause":
            this.pause();
            break;
          case "play":
            this.play();
            break;
          case "stop":
            this.stop();
            break;
          case "autoplay":
            this.autoplay();
            break;
        }
      }).bind(this)
    );
  }
  inViewHandler() {
    const rect = this.getBoundingClientRect();
    if (rect.top < window.innerHeight && rect.bottom > 0) {
      this.classList.remove("out-of-view");
      if (this.pausedByView) {
        this.autoplay();
        this.pausedByView = false;
      }
    } else {
      this.classList.add("out-of-view");
      if (this.playing) {
        this.pausedByView = true;
        this.stop();
      }
    }
  }
  resize() {
    const scrollPosition = this.carouselContainer.scrollLeft;
    const scrollWidthBefore = this.carouselContainer.scrollWidth;
    const relativePosition = scrollPosition / scrollWidthBefore;

    let duplicate = (() => {
      if (
        this.carouselContainer.offsetWidth >
        this.carouselBlocksWrapper.scrollWidth
      ) {
        this.duplicateNodesToEnd(this.carouselBlocksWrapper);
        this.duplicateNodesToEnd(this.carouselBlocksWrapperLeft);
        this.duplicateNodesToEnd(this.carouselBlocksWrapperRight);
        duplicate();
      }
    }).bind(this);
    duplicate();

    this.carouselContainer.scrollTo({
      left: this.carouselContainer.scrollWidth * relativePosition,
      behavior: "auto",
    });
  }

  duplicateNodesToEnd(element) {
    const children = element.children;
    const numChildren = children.length;

    for (let i = 0; i < numChildren; i++) {
      const child = children[i];
      const clone = child.cloneNode(true);
      element.appendChild(clone);
    }
  }

  disconnectedCallback() {
    // Clear interval when element is removed from DOM
    clearInterval(this.intervalId);
  }

  scrollHandle() {
    /* check if user is in view */

    const blocksWrapperWidth = this.carouselBlocksWrapper.offsetWidth;
    const scrollPosition = this.carouselContainer.scrollLeft;
    if (
      scrollPosition + this.carouselContainer.offsetWidth / 2 >=
      2 * blocksWrapperWidth
    ) {
      this.carouselContainer.scrollTo({
        left: scrollPosition - blocksWrapperWidth,
        behavior: "auto",
      });
    } else if (
      scrollPosition + this.carouselContainer.offsetWidth / 2 <=
      blocksWrapperWidth
    ) {
      this.carouselContainer.scrollTo({
        left: scrollPosition + blocksWrapperWidth,
        behavior: "auto",
      });
    }
    if (this.lastPosition != scrollPosition) {
      this.lastPosition = scrollPosition;
      this.checkPosition();
    }
  }
  pause() {
    this.playing = false;
    // dispatch state
    this.dispatchEvent(
      new CustomEvent("carousel:state:change", { detail: { state: "paused" } })
    );
  }

  /* Stop autoplay */
  stop() {
    console.log("stopping autoplay");
    this.pause();
    this.stopped = true;
    // dispatch state
    this.dispatchEvent(
      new CustomEvent("carousel:state:change", { detail: { state: "stopped" } })
    );
  }

  /*
   * Play autoplay
   */
  autoplay() {
    this.stopped = false;
    // dispatch state
    this.dispatchEvent(
      new CustomEvent("carousel:state:change", { detail: { state: "started" } })
    );
    this.play();
    console.log("autoplay!");
  }

  /**
   * Starts auto-scrolling the carousel container in the current direction.
   */
  play() {
    if (this.playing || this.stopped) {
      return;
    }
    // dispatch state
    this.dispatchEvent(
      new CustomEvent("carousel:state:change", { detail: { state: "playing" } })
    );

    this.playing = true;
    const speed = this.speed * 10; // pixels per second
    let lastTimestamp = performance.now();
    let scroll = (timestamp) => {
      const elapsed = timestamp - lastTimestamp;
      const distance = (elapsed * speed) / 1000;
      if (distance > 1) {
        lastTimestamp = timestamp;
        const targetScroll =
          this.direction === "to-right"
            ? this.carouselContainer.scrollLeft + distance
            : this.carouselContainer.scrollLeft - distance;
        this.carouselContainer.scrollLeft = targetScroll;
      }
      if (this.playing) {
        requestAnimationFrame(scroll);
      }
    };
    requestAnimationFrame(scroll);
  }

  forward() {
    if (
      this.getAttribute("move-by-blocks") &&
      this.getAttribute("move-by-blocks") == "true"
    ) {
      this.checkPosition();
      const next = (this.currentBlock.nth + 1) % this.blocks.length;
      this.set(next, "smooth", false);
    } else {
      const scrollPosition = this.carouselContainer.scrollLeft;
      this.carouselContainer.scrollTo({
        left: scrollPosition + this.carouselContainer.offsetWidth / 2,
        behavior: "smooth",
      });
    }
  }
  backward() {
    if (
      this.getAttribute("move-by-blocks") &&
      this.getAttribute("move-by-blocks") == "true"
    ) {
      this.checkPosition();
      const previous =
        (this.currentBlock.nth - 1 + this.blocks.length) % this.blocks.length;
      this.set(previous, "smooth", false);
    } else {
      const scrollPosition = this.carouselContainer.scrollLeft;
      this.carouselContainer.scrollTo({
        left: scrollPosition - this.carouselContainer.offsetWidth / 2,
        behavior: "smooth",
      });
    }
  }
  set(nth, behavior = "smooth", stop = true) {
    const target = this.carouselBlocksWrapper.querySelectorAll(
      ".infinity-carousel-block"
    )[nth];
    const left = (this.carouselContainer.offsetWidth - target.offsetWidth) / 2;
    let spaceAround = 0.0598 * window.innerWidth;
    spaceAround = spaceAround > 48 ? 48 : spaceAround;
    if (target) {
      this.carouselContainer.scrollTo({
        left: target.offsetLeft - (left > spaceAround ? left : spaceAround),
        behavior: behavior,
      });
    }
    if (stop) this.stop();
  }
  checkPosition() {
    const containerPosition = this.carouselContainer.getBoundingClientRect();
    const block = document.elementFromPoint(
      containerPosition.left + containerPosition.width / 2,
      containerPosition.top + containerPosition.height / 2
    );
    if (block) {
      const carouselBlock = block.closest(".infinity-carousel-block");
      if (carouselBlock) {
        const carouselBlockId = carouselBlock.getAttribute("nth");
        if (!this.currentBlock || this.currentBlock.id != carouselBlockId) {
          this.currentBlock = {
            id: carouselBlockId,
            element: carouselBlock,
            nth: parseInt(carouselBlock.getAttribute("nth")) - 1,
          };
          this.dispatchEvent(
            new CustomEvent("carousel:status:change", {
              detail: { current: this.currentBlock },
            })
          );
        }
      }
    }
  }
  clickMouse(event) {
    // Get the boundaries of the element
    const rect = this.carouselContainer.getBoundingClientRect();
    const minX = rect.left;
    const minY = rect.top;
    const maxX = rect.width;
    const maxY = rect.height;

    // Calculate the position of the cursor relative to the element
    const x = event.clientX;
    const y = event.clientY - minY;
    if (x <= maxX * 0.25 && y < maxY) {
      event.preventDefault();
      this.backward();
      console.log("B");
    } else if (x >= maxX * 0.75 && y < maxY) {
      event.preventDefault();
      this.forward();
      console.log("F");
    }
  }
  mouseMove(event) {
    // Get the boundaries of the element
    const rect = this.carouselContainer.getBoundingClientRect();
    const minX = rect.left;
    const minY = rect.top;
    const maxX = rect.width;
    const maxY = rect.height;

    // Calculate the position of the cursor relative to the element
    const x = event.clientX;
    const y = event.clientY - minY;

    let arrow,
      hideArrows = false;
    if (x <= maxX * 0.25 && y < maxY) {
      arrow = this.arrows.left;
      hideArrows = [this.arrows.right];
      this.classList.add("hide-cursor");
    } else if (x >= maxX * 0.75 && y < maxY) {
      arrow = this.arrows.right;
      hideArrows = [this.arrows.left];
      this.classList.add("hide-cursor");
    } else {
      hideArrows = [this.arrows.left, this.arrows.right];
      this.classList.remove("hide-cursor");
    }

    if (arrow) {
      // Restrict the movement of the icon within the boundaries of the element
      const iconWidth = arrow.offsetWidth;
      const iconHeight = arrow.offsetHeight;

      const iconX = x - iconWidth / 2;
      const iconY = y;

      // Move the icon to the new position
      arrow.style.left = `${iconX}px`;
      arrow.style.top = `${iconY}px`;
      arrow.classList.remove("not-visible");
    }
    if (hideArrows) {
      hideArrows.forEach((arrow) => arrow.classList.add("not-visible"));
    }
  }
  hideArrows() {
    this.classList.remove("hide-cursor");
    if (this.arrows.left && this.arrows.right) {
      this.arrows.left.classList.add("not-visible");
      this.arrows.right.classList.add("not-visible");
    }
  }
}

customElements.define("barracuda-infinity-carousel", InfinityCarousel);

customElements.define(
  "barracuda-carousel-state",
  class extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      defer(
        (() => {
          this.carousel = this.closest("barracuda-infinity-carousel");
          this.state =
            this.speed == 0 ? false : this.getAttribute("autoplay") === "true";
          if (this.state) this.stateChange("started");
          else this.stateChange("stopped");

          this.carousel.addEventListener(
            "carousel:state:change",
            ((event) => {
              let state = event.detail.state;
              if (state == "started" || state == "stopped")
                this.stateChange(state);
            }).bind(this)
          );
        }).bind(this)
      );
    }
    stateChange(state) {
      this.querySelectorAll(".state:not(." + state + ")").forEach((element) => {
        element.classList.add("hidden");
      });
      this.querySelectorAll(".state." + state).forEach((element) => {
        element.classList.remove("hidden");
      });
    }
  }
);

customElements.define(
  "barracuda-object-dots",
  class extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      defer(
        (() => {
          // Init array
          this.dots = [];

          // Get dots style
          this.dotStyle = this.getAttribute("dot-style")
            ? this.getAttribute("dot-style")
            : "default";

          // Generate all dots
          this.generate();

          // Set current dot
          this.set(
            parseInt(
              this.getAttribute("current") ? this.getAttribute("current") : 0
            )
          );

          // Get type of object
          this.type = this.getAttribute("object");

          switch (this.type) {
            case "carousel":
              // Add listeners for Carousel
              this.closest("barracuda-infinity-carousel").addEventListener(
                "carousel:status:change",
                ((event) => {
                  this.set(event.detail.current.id - 1);
                }).bind(this)
              );
              break;
            case "slideshow":
              // Add listeners for Slideshow
              this.closest("barracuda-slideshow-core").addEventListener(
                "slideshow:slide:unloaded",
                ((event) => {
                  if (event.detail.sectionId == this.getAttribute("section-id"))
                    this.set(event.detail.to.index);
                }).bind(this)
              );
              break;
          }

          // Set timer and mark as initialized
          setTimeout(
            (() => {
              this.classList.add("initialized");
            }).bind(this),
            200
          );
        }).bind(this)
      );
    }
    generate() {
      // Clean inside
      this.innerHTML = "";
      // Get dots count
      let count = parseInt(
        this.getAttribute("count") ? this.getAttribute("count") : 0
      );
      // If we have count...
      if (count > 0) {
        for (let index = 0; index < count; index++) {
          // Create element
          let dot = document.createElement("span");
          // Add classes
          dot.classList.add("barracuda-object-dot");
          // Add dot-style
          dot.classList.add("dot-style-" + this.dotStyle);
          // Add click listener
          dot.addEventListener(
            "click",
            (() => {
              switch (this.type) {
                case "carousel":
                  // pause carousel
                  this.closest("barracuda-infinity-carousel").dispatchEvent(
                    new CustomEvent("carousel:action", {
                      detail: { action: "stop" },
                    })
                  );
                  // set nth slide
                  this.closest("barracuda-infinity-carousel").dispatchEvent(
                    new CustomEvent("carousel:action", {
                      detail: { action: "set", nth: index },
                    })
                  );
                  break;
                case "slideshow":
                  // pause slideshow
                  this.closest("barracuda-slideshow-core").dispatchEvent(
                    new CustomEvent("slideshow:action", {
                      detail: { action: "pause" },
                    })
                  );
                  // set nth slide
                  this.closest("barracuda-slideshow-core").dispatchEvent(
                    new CustomEvent("slideshow:action", {
                      detail: { action: "set", nth: index },
                    })
                  );
                  break;
              }
            }).bind(this)
          );
          // Append to element
          this.appendChild(dot);
          // append to global array
          this.dots[index] = dot;
        }
      }
    }
    set(nth) {
      if (!(this.current == nth)) {
        // remove class from current dot (only if we know current dot)
        if (this.current != undefined)
          this.dots[this.current].classList.remove("active");
        // asign new current
        this.current = nth;
        // Add class to current dot
        this.dots[this.current].classList.add("active");

        // Change dots visibility
        let visibleDots = parseInt(
          this.getAttribute("visible-dots")
            ? this.getAttribute("visible-dots")
            : 0
        );
        let visibleDotsMargin =
          visibleDots > 1 ? parseInt((visibleDots - 1) / 2) : 0;
        if (visibleDots > 0) {
          function dotsVisibility(dots, from = null, to = null) {
            if (dots.length > 0) {
              dots.forEach((dot) => {
                dot.classList.remove("end");
                dot.classList.add("visible");
              });
              if (from) {
                for (let i = 0; i < from; i++) {
                  if (dots[i]) dots[i].classList.remove("visible");
                }
                if (dots[from]) dots[from].classList.add("end");
              }
              if (to) {
                for (let i = to; i < dots.length; i++) {
                  if (dots[i]) dots[i].classList.remove("visible");
                }
                if (dots[to - 1] && to != dots.length)
                  dots[to - 1].classList.add("end");
              }
            }
          }
          var dotsCount = this.dots.length;
          if (this.dots.length <= visibleDots) dotsVisibility(this.dots);
          else if (this.current <= visibleDotsMargin)
            dotsVisibility(this.dots, null, visibleDots);
          else if (this.current + visibleDotsMargin >= dotsCount) {
            dotsVisibility(this.dots, dotsCount - visibleDots, null);
          } else
            dotsVisibility(
              this.dots,
              this.current - visibleDotsMargin,
              this.current + 1 + visibleDotsMargin
            );
        }
      }
    }
  }
);

customElements.define(
  "barracuda-infinity-carousel-numbers",
  class extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      defer(
        (() => {
          this.carousel = this.closest("barracuda-infinity-carousel");
          this.number = this.querySelector(".current");
          if (this.carousel) {
            this.carousel.addEventListener(
              "carousel:status:change",
              this.changeNumber.bind(this)
            );
          }
        }).bind(this)
      );
    }
    changeNumber(e) {
      const number = parseInt(e.detail.current.id);
      this.number.innerHTML = number < 10 ? "0" + number : number;
    }
  }
);

customElements.define(
  "barracuda-infinity-carousel-button-cursor",
  class extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      defer(
        (() => {
          this.icon = this.querySelector(".google-icon");
          this.icon.style.position = "absolute";
          this.addEventListener("mousemove", this.mouseMove.bind(this));
        }).bind(this)
      );
    }
    mouseMove(event) {
      if (this.icon) {
        // Get the boundaries of the element
        const rect = this.getBoundingClientRect();
        const minX = rect.left;
        const minY = rect.top;
        const maxX = rect.width;
        const maxY = rect.height;

        // Calculate the position of the cursor relative to the element
        const x = event.clientX - minX;
        const y = event.clientY - minY;

        // Restrict the movement of the icon within the boundaries of the element
        const iconWidth = this.icon.offsetWidth;
        const iconHeight = this.icon.offsetHeight;

        const iconX = Math.min(
          Math.max(x - iconWidth / 2, 0 - 48),
          maxX - iconWidth + 48
        );
        const iconXsafe = Math.min(
          Math.max(x - iconWidth / 2, 0),
          maxX - iconWidth
        );

        const iconY = Math.min(
          Math.max(y - iconHeight / 2, 0),
          maxY - iconHeight
        );

        iconX != iconXsafe
          ? this.icon.classList.add("not-visible")
          : this.icon.classList.remove("not-visible");

        // Move the icon to the new position
        this.icon.style.left = `${iconX}px`;
        this.icon.style.top = `${iconY}px`;
      }
    }
  }
);

class BarracudaMoveWithScroll extends HTMLElement {
  constructor() {
    super();
    this.lastPosition = 0;
  }

  connectedCallback() {
    defer(
      (() => {
        this.element = this.parentNode;
        this.container = this.getAttribute("container")
          ? this.closest(this.getAttribute("container"))
          : this.element;
        this.firstContent = this.closest(".first-of-content") ? true : false;
        this.compenzation = this.firstContent
          ? 0
          : (window.innerHeight - this.container.offsetHeight) / 2;
        window.addEventListener("scroll", this.pageScroll.bind(this), false);
      }).bind(this)
    );
  }

  pageScroll() {
    const elementBounding = this.container.getBoundingClientRect();
    const relativePosition = elementBounding.top - this.compenzation;
    if (
      window.scrollY >= 0 &&
      relativePosition <= window.innerHeight &&
      relativePosition >= -1 * window.innerHeight
    ) {
      this.lastPosition = relativePosition;
      this.element.style.setProperty("--translateY", this.lastPosition + "px");
    }
  }
}

customElements.define("barracuda-move-with-scroll", BarracudaMoveWithScroll);

/* Varinat pickers */
customElements.define(
  "barracuda-variant-picker",
  class extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.style = this.getAttribute("picker-style");
      this.selectElement = this.querySelector("select");
      this.optionsElements = this.selectElement.querySelectorAll("option");
      this.optionsElements.forEach((option) => {
        if (option.hasAttribute("thumbnail-url"))
          this.addThumbnailToOption(option);
        option.addEventListener(
          "option:changeAttribute",
          this.addThumbnailToOption.bind(this, option)
        );
      });
      this.currentValueSpan = this.querySelector("span.selected-value");
      this.optionsFrame = this.querySelector(".options-frame");

      if (this.optionsFrame) {
        this.swatches = this.optionsFrame.querySelectorAll(".swatch");
        this.swatches.forEach((swatch) => {
          swatch.addEventListener(
            "option:change",
            this.optionChange.bind(this)
          );
        });
      }

      /* Add availability */
      this.setAvailability();
      this.selectElement.addEventListener(
        "refresh:availability",
        this.setAvailability.bind(this)
      );
      /* Set same size */
      this.resize();
      window.addEventListener("resize", this.resize.bind(this));
    }
    addThumbnailToOption(option) {
      let swatch = this.querySelector(
        ".swatch[data-value=val-" + option.value + "]"
      );
      if (swatch) {
        const image = swatch.querySelector("img");
        if (!image) {
          const thumbnail = document.createElement("img");
          const src = option.getAttribute("thumbnail-url");
          console.log(src);
          if (
            src &&
            typeof src !== undefined &&
            src != null &&
            src != "undefined"
          ) {
            thumbnail.src = src;
            thumbnail.classList.add("thumbnail");
            swatch.appendChild(thumbnail);
          }
        }
      }
    }
    setAvailability() {
      if (this.optionsFrame) {
        this.swatches = this.optionsFrame.querySelectorAll(".swatch");
        this.swatches.forEach((swatch) => {
          const value = swatch.getAttribute("value");
          const option = this.selectElement.querySelector(
            "option[data-value=val-" + value + "]"
          );
          if (option) {
            if (
              option.getAttribute("disabled") &&
              option.getAttribute("disabled") == "true"
            )
              swatch.classList.add("disabled");
            else swatch.classList.remove("disabled");

            const dot = swatch.querySelector("span.availability_dot");
            const color = option.getAttribute("availability-dot");
            if (dot && color) {
              dot.setAttribute("class", "availability_dot");
              dot.style.removeProperty("background-color");
              if (color != "transparent") {
                dot.classList.add("visible");
                dot.style.backgroundColor = color;
              }
            }
          }
        });
      }
    }
    resize() {
      if (this.optionsFrame) {
        let maxWidth = 0;
        this.optionsFrame.style.setProperty("--same-width", 0 + "px");
        this.swatches.forEach((swatch) => {
          const width = swatch.offsetWidth;
          if (width > maxWidth) maxWidth = width;
        });
        const countOfSwatches = this.swatches.length;
        const gapSize = parseInt(
          window.getComputedStyle(this.optionsFrame).getPropertyValue("gap")
        );
        const width = this.optionsFrame.clientWidth;
        if (countOfSwatches * (maxWidth + gapSize + 2) + maxWidth + 2 > width) {
          const numOfSwatchesPerLine = Math.floor(
            (width + gapSize) / (maxWidth + gapSize + 2)
          );
          maxWidth = (width + gapSize) / numOfSwatchesPerLine - gapSize - 2;
        }
        this.optionsFrame.style.setProperty("--same-width", maxWidth + "px");
      }
    }
    optionChange(event) {
      this.selectElement.value = event.detail.value;
      const selected = this.querySelector(".selected");
      if (selected) selected.classList.remove("selected");
      if (event.detail.element) {
        event.detail.element.classList.add("selected");
        if (
          event.detail.element.querySelector(".label") &&
          this.currentValueSpan
        )
          this.currentValueSpan.innerText =
            event.detail.element.querySelector(".label").innerText;
      }
      this.selectElement.dispatchEvent(new Event("change"));
    }
  }
);

customElements.define(
  "barracuda-product",
  class BarracudaProduct extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.element = this.closest("form");
      this.element.classList.add("barracuda-product-initialized");
      this.parentEl = this.element.closest(".product-part");
      this.debug = false;
      if (this.element) {
        this.init();
      }
    }

    init() {
      /* Get all Product's variants */
      this.productVariants = {};
      this.element
        .querySelectorAll(".variant-data-source")
        .forEach((element) => {
          var variant_id = element.dataset.id;
          this.productVariants[variant_id] = {};
          element.querySelectorAll("span").forEach((el) => {
            this.productVariants[variant_id][el.dataset.mapas] = el.innerText;
          });
        });

      /* Get selected options */
      var x = this.element.querySelector("select[name=id] option[selected]");
      if (x) {
        this.selectedOptions = {
          1: x.dataset.option1,
          2: x.dataset.option2,
          3: x.dataset.option3,
        };
      }

      /* Mark unavailable options */
      // this.markUnavailableOptions();
      this.addThumbnailsToOptions();

      /* add Event listeners for options selectors */
      this.element.querySelectorAll(".option-selector").forEach((el) => {
        el.addEventListener(
          "change",
          (() => {
            this.optionChange(el.dataset.position, el.value);
          }).bind(this),
          false
        );
      });

      /* add Event listeners for selected options from subscription selector */
      if (
        this.element.querySelector(
          ".barracuda-select select[name=selling_plan]"
        )
      )
        this.element
          .querySelector(".barracuda-select select[name=selling_plan]")
          .addEventListener(
            "change",
            (() => {
              var el = this.element.querySelector("select[name=selling_plan]");
              el = this.element.querySelectorAll(
                "select[name=selling_plan] option"
              )[el.selectedIndex];
              if (el) {
                if (el.value == "") {
                  for (var i = 1; i <= 3; i++) {
                    var optionSelect = this.element.querySelector(
                      "select[name=option" + i + "]"
                    );
                    if (optionSelect) {
                      optionSelect.disabled = false;
                      optionSelect.parentElement.classList.remove("disabled");
                    }
                  }
                } else {
                  var opt = [];
                  opt[1] = el.dataset.option1;
                  opt[2] = el.dataset.option2;
                  opt[3] = el.dataset.option3;

                  for (var i = 1; i <= 3; i++) {
                    var optionSelect = this.element.querySelector(
                      "select[name=option" + i + "]"
                    );
                    if (optionSelect) {
                      optionSelect.value = opt[i];
                      optionSelect.disabled = true;
                      optionSelect.parentElement.classList.add("disabled");
                    }
                  }

                  var selector =
                    "select[name=id] option.option1-" +
                    opt[1] +
                    ".option2-" +
                    opt[2] +
                    ".option3-" +
                    opt[3];
                  var selectedOption = this.element.querySelector(selector);

                  var selectedVariantId = selectedOption.value;
                  /* Set url to variants url */
                  if (history.replaceState) {
                    var newUrl = ""
                      .concat(window.location.protocol, "//")
                      .concat(window.location.host)
                      .concat(window.location.pathname, "?variant=")
                      .concat(selectedVariantId);
                    window.history.replaceState(
                      {
                        path: newUrl,
                      },
                      "",
                      newUrl
                    );
                  }

                  // We need set variant id to master select
                  this.element
                    .querySelector("select[name=id]")
                    .querySelector("[selected]")
                    .removeAttribute("selected");
                  this.element
                    .querySelector("select[name=id]")
                    .querySelector('[value="'.concat(selectedVariantId, '"]'))
                    .setAttribute("selected", "selected");

                  // Allow system monitoring the name attribute to work
                  this.element.querySelector("select[name=id]").dispatchEvent(
                    new Event("change", {
                      bubbles: true,
                    })
                  );
                }
              }
            }).bind(this),
            false
          );
    }
    addThumbnailsToOptions() {
      let options = this.element.querySelectorAll(
        "select.option-selector.thumbnails option"
      );
      options.forEach((el) => {
        if (!el.hasAttribute("thumbnail-url")) {
          const position = el.dataset.position;
          const selector =
            "select[name=id] option." + position + "-" + el.value;
          const variant = this.element.querySelector(selector);
          if (variant) {
            el.setAttribute("thumbnail-url", variant.dataset.featuredImage);
            el.dispatchEvent(new CustomEvent("option:changeAttribute"));
          }
        }
      });
    }
    markUnavailableOptions() {
      let setLastOptionAttr = function (element, selector) {
        const variants = this.element.querySelectorAll(selector);
        if (variants.length <= 1) {
          const variant = variants[0];
          if (variant && variant.dataset.availability == "true") {
            element.removeAttribute("disabled");
          } else {
            element.setAttribute("disabled", true);
          }
          if (variant && variant.getAttribute("data-availability-dot")) {
            element.setAttribute(
              "availability-dot",
              variant.getAttribute("data-availability-dot")
            );
          }
        } else {
          let available = false;
          variants.forEach((el) => {
            if (el.dataset.availability == "true") available = true;
          });
          if (available) {
            element.removeAttribute("disabled");
          } else {
            element.setAttribute("disabled", true);
          }
        }
      }.bind(this);

      let option1Values = this.element.querySelectorAll(
        "select[name=option1] option"
      );
      let option1Selector = this.element.querySelector("select[name=option1]");
      let option2Values = this.element.querySelectorAll(
        "select[name=option2] option"
      );
      let option2Selector = this.element.querySelector("select[name=option2]");
      let option3Values = this.element.querySelectorAll(
        "select[name=option3] option"
      );
      let option3Selector = this.element.querySelector("select[name=option3]");

      option3Values.forEach((el3) => {
        let selector =
          'select[name="id"] option.option1-' +
          this.selectedOptions["1"] +
          ".option2-" +
          this.selectedOptions["2"] +
          ".option3-" +
          el3.getAttribute("value");
        setLastOptionAttr(el3, selector);
      });
      if (option3Selector)
        option3Selector.dispatchEvent(new CustomEvent("refresh:availability"));

      option2Values.forEach((el2) => {
        let selector =
          'select[name="id"] option.option1-' +
          this.selectedOptions["1"] +
          ".option2-" +
          el2.getAttribute("value");
        setLastOptionAttr(el2, selector);
      });
      if (option2Selector)
        option2Selector.dispatchEvent(new CustomEvent("refresh:availability"));

      option1Values.forEach((el1) => {
        let selector =
          'select[name="id"] option.option1-' + el1.getAttribute("value");
        setLastOptionAttr(el1, selector);
      });
      if (option1Selector)
        option1Selector.dispatchEvent(new CustomEvent("refresh:availability"));
    }
    optionChange(position, value) {
      this.selectedOptions[position] = value;

      /* get variant id from master select */
      const selector =
        'select[name="id"] option.option1-' +
        this.selectedOptions[1] +
        ".option2-" +
        this.selectedOptions[2] +
        ".option3-" +
        this.selectedOptions[3];
      const selectedVariantOption = this.element.querySelector(selector);
      /* Test if variant exists in master select */
      if (selectedVariantOption) {
        console.log(selectedVariantOption);
        let selectedVariantId = selectedVariantOption.value;

        // We need set variant id to master select
        this.element
          .querySelector("select[name=id]")
          .querySelector("[selected]")
          .removeAttribute("selected");
        this.element
          .querySelector("select[name=id]")
          .querySelector('[value="'.concat(selectedVariantId, '"]'))
          .setAttribute("selected", "selected");

        // Allow system monitoring the name attribute to work
        this.element.querySelector("select[name=id]").dispatchEvent(
          new Event("change", {
            bubbles: true,
          })
        );

        /* Move to variant image in gallery */
        if (this.parentEl.querySelector("barracuda-product-gallery")) {
          this.parentEl
            .querySelector("barracuda-product-gallery")
            .goto(
              ".media-" + this.productVariants[selectedVariantId].variant_media
            );
        }

        /* Set url to variant url */
        BarracudaStore.functions.updateQueryString(
          "variant",
          selectedVariantId
        );

        let url = new URL(
          selectedVariantOption.dataset.variantUrl,
          window.location.origin + window.Shopify.routes.root
        );
        url.searchParams.append("section_id", this.getAttribute("section-id"));
        /* Get new product detail text */
        let callback = (status, response) => {
          let rawData = new DOMParser().parseFromString(response, "text/html");
          if (!rawData.querySelector(".product-form")) {
            rawData =
              !rawData.querySelector("template").content.firstElementChild;
          }
          let data = rawData.querySelector(".product-form");
          let oldData = this.element.closest(".product-form");

          let blocks = data.querySelectorAll(".block");
          blocks.forEach((block) => {
            if (!block.classList.contains("not-replace")) {
              const id = block.getAttribute("id");
              const oldOne = oldData.querySelector("#" + id);
              if (oldOne) {
                oldOne.parentNode.replaceChild(block, oldOne);
              }
            }
          });

          let gallery = rawData.querySelector("barracuda-product-gallery");
          let oldGallery = this.parentEl.querySelector(
            "barracuda-product-gallery"
          );
          console.log("new gallery:", gallery, " oldGallery:", oldGallery);
          if (gallery && oldGallery) {
            oldGallery.parentNode.replaceChild(gallery, oldGallery);
            console.log("Replaced gallery");
          }

          window.requestAnimationFrame(() => {
            // this.markUnavailableOptions();
            Barracuda.elements.init();
            Barracuda.reInit();
          });

          /* hide max quantity (can be unhidden when user try add more items to cart) */
          if (this.element.querySelector(".cant-add-more")) {
            this.element
              .querySelector(".cant-add-more")
              .classList.add("visually-hidden");
          }

          /* Enable or Disable AddToCart button */
          var button = this.element.querySelector(
            ".barracuda-cart-addToCartButton"
          );
          var dynamicButtons = this.element.querySelector(".dynamic-buy");
          if (
            button &&
            this.productVariants[selectedVariantId].available == "true"
          ) {
            button.classList.remove("disabled");
            button.innerText =
              this.productVariants[selectedVariantId].add_to_cart;
            if (dynamicButtons) dynamicButtons.classList.remove("hidden");
          } else if (
            button &&
            this.productVariants[selectedVariantId].available == "false"
          ) {
            button.classList.add("disabled");
            button.innerText = button.dataset.unavailable;
            if (dynamicButtons) dynamicButtons.classList.add("hidden");
          } else {
            console.warn("Add to Cart button not found");
          }
        };
        let xhr = new XMLHttpRequest();
        xhr.open("GET", url.href);
        xhr.onload = () => {
          const status = xhr.status;
          if (status === 0 || (status >= 200 && status < 400)) {
            callback(status, xhr.responseText);
          }
        };
        xhr.send();
      } else {
        /* Variant unavailable */
        //   this.markUnavailableOptions();
        const selector =
            'select[name="id"] option.option1-' + this.selectedOptions[1],
          firstAvailableVariantOption = this.element.querySelector(selector);
        if (firstAvailableVariantOption) {
          this.parentEl.querySelector("barracuda-product-gallery") &&
            this.parentEl
              .querySelector("barracuda-product-gallery")
              .goto(
                ".media-" +
                  this.productVariants[firstAvailableVariantOption.value]
                    .variant_media
              );
        }

        var button = this.element.querySelector(
          ".barracuda-cart-addToCartButton"
        );
        var dynamicButtons = this.element.querySelector(".dynamic-buy");
        if (button) {
          button.classList.add("disabled");
          button.innerText = button.dataset.unavailable;
        }
        if (dynamicButtons) dynamicButtons.classList.add("hidden");
      }
    }
  }
);
